import defaultMember from './defaultMember';

/**
 * @public
 * Gets default Member object.
 *
 * @return {Object}
 */
export default function getDefaultMember() {
  return JSON.parse(JSON.stringify(defaultMember));
}
